import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 .75H3c-.825 0-1.5.675-1.5 1.5v10.5H3V2.25h9V.75zm2.25 3H6c-.825 0-1.5.675-1.5 1.5v10.5c0 .825.675 1.5 1.5 1.5h8.25c.825 0 1.5-.675 1.5-1.5V5.25c0-.825-.675-1.5-1.5-1.5zm0 12H6V5.25h8.25v10.5z" fill="#54585D" /></svg>);